import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Breadcrumbs from '@/components/SkuBreadcrumbs';
import Image from 'next/image';
import Button from 'react-bootstrap/Button';
import shareIcon from '@/public/images/icons/share.svg';
import plusIcon from '@/public/images/icons/plus.svg';
import heartIcon from '@/public/images/icons/heart.svg';
import heartIconFilled from '@/public/images/icons/heart-filled.svg';
import { useState } from 'react';
import EmailVerificationModal from '../email-verification-modal';
import translationFallback from '@/utilites/translations/translationFallback';
import { SkuTopActionsProps } from '@/types/props/components/skus';
import ConditionalRender from '../common/ConditionalRender';
import useWishlist from '@/hooks/useWishlist';

export default function SkuTopActions({
  skuSlug,
  skuName,
  userAuthenticated,
  tSkus,
  skuCategoryName,
  skuCountryOfOrigin,
  handleOpenPortfolioModal,
  setShowShareModal,
  sku,
}: SkuTopActionsProps) {
  const { addWishlist, isInWishlist } = useWishlist();
  const [modalShow, setModalShow] = useState(false);
  return (
    <>
      <EmailVerificationModal
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
      <Row className="py-4">
        <Col>
          <Breadcrumbs
            skuCategoryName={skuCategoryName}
            skuCountryOfOrigin={skuCountryOfOrigin}
            skuName={skuName}
          />
        </Col>
        <Col className="d-flex justify-content-end">
          <ConditionalRender condition={userAuthenticated}>
            <Button
              variant="s-outline-light"
              className="me-3 rounded-10"
              onClick={(e) => addWishlist(sku)}
            >
              <Image
                src={isInWishlist(sku.slug) ? heartIconFilled : heartIcon}
                width={23}
                height={20}
                alt={
                  isInWishlist(skuSlug)
                    ? translationFallback(
                        'navBar.remove_from_wishlist',
                        tSkus('navBar.remove_from_wishlist'),
                        'Remove from Wishlist'
                      )
                    : translationFallback(
                        'navBar.add_to_wishlist',
                        tSkus('navBar.add_to_wishlist'),
                        'Add to Wishlist'
                      )
                }
                className="me-2"
              />
              {isInWishlist(skuSlug)
                ? translationFallback(
                    'navBar.remove_from_wishlist',
                    tSkus('navBar.remove_from_wishlist'),
                    'Remove from Wishlist'
                  )
                : translationFallback(
                    'navBar.add_to_wishlist',
                    tSkus('navBar.add_to_wishlist'),
                    'Add to Wishlist'
                  )}
            </Button>
            <Button
              variant="s-outline-light"
              className="me-3 rounded-10"
              onClick={handleOpenPortfolioModal}
            >
              <Image
                src={plusIcon}
                width={24}
                height={24}
                alt={translationFallback(
                  'navBar.add_to_your_portfolio',
                  tSkus('navBar.add_to_your_portfolio'),
                  'Add to your portfolio'
                )}
                className="me-2"
              />
              {translationFallback(
                'navBar.add_to_your_portfolio',
                tSkus('navBar.add_to_your_portfolio'),
                'Add to your portfolio'
              )}
            </Button>
          </ConditionalRender>
          <Button
            variant="s-outline-light"
            className="rounded-10"
            onClick={() => setShowShareModal(true)}
          >
            <Image
              src={shareIcon}
              width={22}
              height={24}
              alt={translationFallback(
                'navBar.share',
                tSkus('navBar.share'),
                'Share'
              )}
              className="me-2"
            />
            {translationFallback(
              'navBar.share',
              tSkus('navBar.share'),
              'Share'
            )}
          </Button>
        </Col>
      </Row>
    </>
  );
}
